"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9046],{

/***/ 79557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Heading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68251);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73098);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 4px;\n  min-height: 70px;\n\n  margin-bottom: 16px;\n  padding: 0 0 0 33px;\n  ",
        " {\n    padding: 0 33px 0 0;\n  }\n\n  font-size: 24px;\n  font-weight: 300;\n  line-height: 1;\n  text-transform: uppercase;\n  color: ",
        ";\n\n  b,\n  strong {\n    font-weight: 300;\n  }\n\n  ",
        " {\n    font-size: 32px;\n    padding: 0 !important;\n  }\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 17px;\n    height: 70px;\n    clip-path: polygon(0 0, 50% 0, 100% 100%, 100% 100%);\n    background: ",
        ";\n\n    ",
        " {\n      left: -37px;\n    }\n\n    ",
        " {\n      left: auto;\n      right: 0;\n      clip-path: polygon(50% 0, 100% 0, 0 100%, 0 100%);\n\n      ",
        " {\n        right: -37px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Heading = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h2.withConfig({
    displayName: "Heading",
    componentId: "sc-981acc5b-0"
})(_templateObject(), src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .dirRTL */ .gX, function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);


/***/ }),

/***/ 43573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ PimImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_services_pim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57539);






var PimImage = function(_param) {
    var src = _param.src, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src"
    ]);
    if (!src) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        src: (0,src_services_pim__WEBPACK_IMPORTED_MODULE_2__/* .getPimImageAssetUrl */ .p3)(src)
    }));
};


/***/ }),

/***/ 95175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ StickyMenuProvider; },
/* harmony export */   "W": function() { return /* binding */ StickyMenuContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49713);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var StickyMenuContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    activeSection: null,
    registeredSections: [],
    registerSection: function() {
        return null;
    },
    handleActiveSectionChange: function() {
        return null;
    }
});
var StickyMenuProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), registeredSections = ref[0], setRegisteredSections = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), activeSection = ref1[0], setActiveSection = ref1[1];
    var _index, _index1;
    var registerSection = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(section) {
        return setRegisteredSections(function(state) {
            return (0,rambda__WEBPACK_IMPORTED_MODULE_3__.sort)(function(a, b) {
                return ((_index = a.index) !== null && _index !== void 0 ? _index : 0) > ((_index1 = b.index) !== null && _index1 !== void 0 ? _index1 : 0) ? 1 : 0;
            }, (0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniqBy)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(state).concat([
                section
            ]), function(s) {
                return s.id;
            }));
        });
    }, [
        setRegisteredSections
    ]);
    var handleActiveSectionChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        setActiveSection(value);
    }, [
        setActiveSection
    ]);
    var value = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            activeSection: activeSection,
            registeredSections: registeredSections,
            registerSection: registerSection,
            handleActiveSectionChange: handleActiveSectionChange
        };
    }, [
        activeSection,
        registeredSections,
        handleActiveSectionChange,
        registerSection, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyMenuContext.Provider, {
        value: value,
        children: children
    });
};


/***/ }),

/***/ 226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ StickyMenuSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var react_hook_inview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69671);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94829);
/* harmony import */ var src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95175);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Section = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].section.withConfig({
    displayName: "StickyMenuSection__Section",
    componentId: "sc-4d2b84b-0"
})(_templateObject());
var StickyMenuSection = function(_param) {
    var id = _param.id, label = _param.label, index = _param.index, threshold = _param.threshold, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "id",
        "label",
        "index",
        "threshold",
        "children"
    ]);
    var isDesktop = (0,react_use__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("(min-width: 992px)", true);
    var activeThreshold = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (typeof threshold === "object" && !Array.isArray(threshold)) {
            if (isDesktop) return threshold.desktop;
            return threshold.mobile;
        }
        return threshold;
    }, [
        threshold,
        isDesktop
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,react_hook_inview__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .Y)({
        threshold: activeThreshold
    }), 2), ref1 = ref[0], isVisible = ref[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_4__/* .StickyMenuContext */ .W), handleActiveSectionChange = ref2.handleActiveSectionChange, registerSection = ref2.registerSection;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isVisible) {
            handleActiveSectionChange(id);
        }
    }, [
        isVisible,
        handleActiveSectionChange,
        id
    ]);
    var hasChildren = !!children;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (id && label && hasChildren) {
            registerSection({
                id: id,
                label: label,
                index: index
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        label,
        hasChildren
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Section, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        ref: ref1,
        id: id !== null && id !== void 0 ? id : undefined,
        children: children
    }));
};


/***/ }),

/***/ 77314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ContentSwiper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72873);
/* harmony import */ var vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10395);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68251);
/* harmony import */ var src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52178);
/* harmony import */ var src_components_icons_ChevronLeft__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18709);
/* harmony import */ var src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38108);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  left: 0;\n  overflow: visible;\n  ",
        " {\n    display: flex;\n    justify-content: center;\n\n    .swiper-wrapper {\n      width: max-content;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var StyledSwiper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t).withConfig({
    displayName: "ContentSwiper__StyledSwiper",
    componentId: "sc-6f9c2f7b-0"
})(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ContentSwiper = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var prevRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var nextRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), swiper = ref[0], setSwiper = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (swiper && prevRef.current && nextRef.current && swiper.navigation) {
            swiper.navigation.init();
            swiper.navigation.update();
        }
    }, [
        swiper
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSwiper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        threshold: 15,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        wrapperTag: "ul",
        onSwiper: setSwiper,
        navigation: {
            prevEl: prevRef.current,
            nextEl: nextRef.current
        }
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__/* .Theme */ .Q, {
                theme: src_styles_theme__WEBPACK_IMPORTED_MODULE_6__/* .darkTheme */ .$_,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_7__/* .NavigationButton */ .W, {
                        kind: "circled",
                        ref: prevRef,
                        icon: src_components_icons_ChevronLeft__WEBPACK_IMPORTED_MODULE_8__/* .ChevronLeft */ .s,
                        $direction: "left"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_7__/* .NavigationButton */ .W, {
                        kind: "circled",
                        ref: nextRef,
                        icon: src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_9__/* .ChevronRight */ ._,
                        $direction: "right"
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 29894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ H1Smaller; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68251);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73098);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        padding: 0 26px;\n        &:before {\n          width: 10px;\n          height: 41px;\n        }\n\n        ",
        " {\n          margin-left: -35px;\n          margin-bottom: 30px;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n      padding-left: 30px;\n\n      ",
        " {\n        padding-left: 40px;\n      }\n\n      &::before {\n        content: '';\n        background-color: currentColor;\n        position: absolute;\n        top: -5px;\n        bottom: 0;\n        height: 70px;\n        left: 5px;\n        width: 17px;\n        clip-path: polygon(0 0, 40% 0, 100% 100%, 90% 100%);\n      }\n\n      ",
        " {\n        padding-left: 0;\n        padding-right: 30px;\n\n        ",
        " {\n          padding-left: 0;\n          padding-right: 40px;\n        }\n\n        &::before {\n          left: auto;\n          right: 5px;\n          clip-path: polygon(60% 0, 100% 0, 10% 100%, 0 100%);\n\n          ",
        " {\n            right: 0;\n          }\n        }\n      }\n\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n\n  font-size: 24px;\n  line-height: 120%;\n\n  color: ",
        ";\n  margin-bottom: 20px;\n\n  ",
        " {\n    font-size: 32px;\n    margin-bottom: 30px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n      padding-left: 12px;\n\n      &::before {\n        content: '';\n        background-color: currentColor;\n        position: absolute;\n        clip-path: polygon(0 0, 40% 0, 100% 100%, 90% 100%);\n        top: -2px;\n        height: 21px;\n        left: 0;\n        width: 5px;\n      }\n\n      ",
        " {\n        padding-left: 0;\n        padding-right: 12px;\n\n        &::before {\n          left: auto;\n          right: 0;\n          clip-path: polygon(60% 0, 100% 0, 10% 100%, 0 100%);\n        }\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 120%;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n\n  color: ",
        ";\n  margin-bottom: 20px;\n\n  ",
        " {\n    font-size: 16px;\n    margin-bottom: 20px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n\n  font-weight: 400;\n  letter-spacing: 0.04em;\n  text-align: left;\n\n  display: flex;\n  align-items: center;\n  text-transform: uppercase;\n\n  color: ",
        ";\n  margin-bottom: ",
        "px;\n\n  ",
        " {\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n  font-weight: 300;\n  text-transform: uppercase;\n  font-size: 14px;\n  line-height: 130%;\n  text-align: center;\n  margin-left: -30px;\n  margin-bottom: 18px;\n  letter-spacing: 2rpx;\n\n  ",
        " {\n    text-align: left;\n    font-size: 16px;\n    letter-spacing: 0.64rpx;\n    margin-left: 0;\n  }\n  ",
        " {\n    margin-left: 0;\n    margin-right: -30px;\n    ",
        " {\n      text-align: right;\n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var H1 = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h1.withConfig({
    displayName: "Header__H1",
    componentId: "sc-7f32335b-0"
})(_templateObject2(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.accent;
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, function(param) {
    var _$nail = param.$nail, $nail = _$nail === void 0 ? true : _$nail;
    return $nail && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, $nail === "outside" && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop));
});
var H1Smaller = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h1.withConfig({
    displayName: "Header__H1Smaller",
    componentId: "sc-7f32335b-1"
})(_templateObject4(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.accent;
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, function(param) {
    var _$nail = param.$nail, $nail = _$nail === void 0 ? true : _$nail;
    return $nail && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject3(), src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .dirRTL */ .gX);
});
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h2.withConfig({
    displayName: "Header__H2",
    componentId: "sc-7f32335b-2"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, function(param) {
    var theme = param.theme;
    return theme.spacing.gap * 0.5;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, function(param) {
    var theme = param.theme;
    return theme.spacing.gap * 0.75;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h3.withConfig({
    displayName: "Header__H3",
    componentId: "sc-7f32335b-3"
})(_templateObject6(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.primary;
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);


/***/ }),

/***/ 51306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 1.5;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].p.withConfig({
    displayName: "Text__Paragraph",
    componentId: "sc-ee167d0d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});


/***/ }),

/***/ 89080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MetaDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaDescription(props) {
    var description = props.children;
    return description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }, "twitter:description")
        ]
    }) : null;
}


/***/ }),

/***/ 74822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qf": function() { return /* binding */ getMultipleProductAttributes; },
/* harmony export */   "c": function() { return /* binding */ ProductAttributeCode; },
/* harmony export */   "ur": function() { return /* binding */ getProductAttribute; },
/* harmony export */   "xi": function() { return /* binding */ ProductAttributeCollection; }
/* harmony export */ });
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49713);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var ProductAttributeCode;
(function(ProductAttributeCode) {
    ProductAttributeCode["AestheticIndicationText"] = "aesthetic-indication-text";
    ProductAttributeCode["AestheticIndicationTitle"] = "aesthetic-indication-title";
    ProductAttributeCode["Application"] = "application";
    ProductAttributeCode["ApplicationTime"] = "application-time";
    ProductAttributeCode["AreaOfInjection"] = "area-of-injection";
    ProductAttributeCode["BeautyRoutines"] = "beauty-routines";
    ProductAttributeCode["BeautyTip"] = "beauty-tip";
    ProductAttributeCode["BooleanAttribute"] = "boolean-attribute";
    ProductAttributeCode["CrossSellingTitle"] = "cross-selling-title";
    ProductAttributeCode["DateTimeAttribute"] = "date-time-attribute";
    ProductAttributeCode["Duration"] = "duration";
    ProductAttributeCode["ExtrusionForce"] = "extrusion-force";
    ProductAttributeCode["FdaIcon"] = "fda-icon";
    ProductAttributeCode["HaConcentration"] = "ha-concentration";
    ProductAttributeCode["HowItWorksGroup"] = "how-it-works-group";
    ProductAttributeCode["HowItWorksGroupImage"] = "how-it-works-group-image";
    ProductAttributeCode["HowItWorksGroupText"] = "how-it-works-group-text";
    ProductAttributeCode["HowItWorksGroupTitle"] = "how-it-works-group-title";
    ProductAttributeCode["HowItWorksSubtitle"] = "how-it-works-subtitle";
    ProductAttributeCode["HowItWorksText"] = "how-it-works-text";
    ProductAttributeCode["Ingredients"] = "ingredients";
    ProductAttributeCode["IngredientsEffectivenessText"] = "ingredients-effectiveness-text";
    ProductAttributeCode["InjectionPlace"] = "injection-place";
    ProductAttributeCode["InjectionTool"] = "injection-tool";
    ProductAttributeCode["KeyBenefitsText"] = "key-benefits-text";
    ProductAttributeCode["KeyBenefitsTitle"] = "key-benefits-title";
    ProductAttributeCode["KeyIngredients"] = "key-ingredients";
    ProductAttributeCode["Leaflet"] = "leaflet";
    ProductAttributeCode["LegalMentions"] = "legal-mentions";
    ProductAttributeCode["FeaturesImage"] = "product-features-image";
    ProductAttributeCode["ProductsInvolvedGroup"] = "products-involved-group";
    ProductAttributeCode["ProductsInvolvedGroupCode"] = "products-involved-group-code";
    ProductAttributeCode["ProductsInvolvedGroupImage"] = "products-involved-group-image";
    ProductAttributeCode["ProductsInvolvedGroupName"] = "products-involved-group-name";
    ProductAttributeCode["ProductsInvolvedGroupProduct"] = "products-involved-group-product";
    ProductAttributeCode["ProductsInvolvedGroupText"] = "products-involved-group-text";
    ProductAttributeCode["ProductsInvolvedText"] = "products-involved-text";
    ProductAttributeCode["ProductsInvolvedTitle"] = "products-involved-title";
    ProductAttributeCode["ProtocolDescriptionText"] = "protocol-description-text";
    ProductAttributeCode["ProtocolDescriptionTitle"] = "protocol-description-title";
    ProductAttributeCode["ProtocolsSessionsGroup"] = "protocols-sessions-group";
    ProductAttributeCode["ProtocolsSessionsGroupStepGroup"] = "protocols-sessions-group-step-group";
    ProductAttributeCode["ProtocolsSessionsGroupStepGroupCode"] = "protocols-sessions-group-step-group-code";
    ProductAttributeCode["ProtocolsSessionsGroupStepGroupProduct"] = "protocols-sessions-group-step-group-product";
    ProductAttributeCode["ProtocolsSessionsGroupStepGroupText"] = "protocols-sessions-group-step-group-text";
    ProductAttributeCode["ProtocolsSessionsGroupStepGroupTitle"] = "protocols-sessions-group-step-group-title";
    ProductAttributeCode["ProtocolsSessionsGroupTitle"] = "protocols-sessions-group-title";
    ProductAttributeCode["ProtocolsSessionsGroupText"] = "protocols-sessions-group-text";
    ProductAttributeCode["ProtocolsSessionsText"] = "protocols-sessions-text";
    ProductAttributeCode["ProtocolsSessionsTitle"] = "protocols-sessions-title";
    ProductAttributeCode["ResultsText"] = "results-text";
    ProductAttributeCode["SctLinkGroup"] = "sct-link-group";
    ProductAttributeCode["SctLinkGroupCode"] = "sct-link-group-code";
    ProductAttributeCode["SctLinkGroupImage"] = "sct-link-group-image";
    ProductAttributeCode["SctLinkGroupName"] = "sct-link-group-name";
    ProductAttributeCode["SctLinkGroupProduct"] = "sct-link-group-product";
    ProductAttributeCode["SctLinkGroupText"] = "sct-link-group-text";
    ProductAttributeCode["StiffnessLevel"] = "stiffness-level";
    ProductAttributeCode["StiffnessText"] = "stiffness-text";
    ProductAttributeCode["TechnicalFeaturesAndHandpieceGroup"] = "technical-features-and-handpiece-group";
    ProductAttributeCode["TechnicalFeaturesAndHandpieceGroupImage"] = "technical-features-and-handpiece-group-image";
    ProductAttributeCode["TechnicalFeaturesAndHandpieceGroupText"] = "technical-features-and-handpiece-group-text";
    ProductAttributeCode["TechnicalFeaturesAndHandpieceGroupTitle"] = "technical-features-and-handpiece-group-title";
    ProductAttributeCode["TechnicalFeaturesAndHandpieceText"] = "technical-features-and-handpiece-text";
    ProductAttributeCode["TestFiles"] = "test-files";
    ProductAttributeCode["TreatmentEssentials"] = "treatment-essentials";
    ProductAttributeCode["TreatmentEssentialsText"] = "treatment-essentials-text";
    ProductAttributeCode["Volume"] = "volume";
})(ProductAttributeCode || (ProductAttributeCode = {}));
var ProductAttributeCollection;
(function(ProductAttributeCollection) {
    ProductAttributeCollection["TextValues"] = "text_values";
    ProductAttributeCollection["GroupValues"] = "group_values";
    ProductAttributeCollection["DictionaryValues"] = "dictionary_values";
    ProductAttributeCollection["StringValues"] = "string_values";
    ProductAttributeCollection["NumericValues"] = "numeric_values";
    ProductAttributeCollection["BooleanValues"] = "boolean_values";
    ProductAttributeCollection["DateTimeValues"] = "date_time_values";
    ProductAttributeCollection["ImagesValues"] = "images_values";
    ProductAttributeCollection["FilesValues"] = "files_values";
    ProductAttributeCollection["LinkedProductsValues"] = "linked_products_values";
})(ProductAttributeCollection || (ProductAttributeCollection = {}));
var parseAttribute = function(attribute) {
    var item = attribute.item;
    if ("value" in item) {
        var isDictionary = !!(Array.isArray(item.value) && item.value.some(function(v) {
            return "dictionary_entries_code" in v;
        }));
        if (isDictionary) {
            return item.value.map(function(v) {
                return v.dictionary_entries_code;
            });
        }
        return item.value;
    }
    return [
        item
    ];
};
var filterAttributesByCodeOrCollection = function(attr, codeOrCollection) {
    var _item = attr.item, code = _item.attribute, collection = attr.collection;
    var isCode = (0,rambda__WEBPACK_IMPORTED_MODULE_0__.values)(ProductAttributeCode).includes(codeOrCollection);
    if (isCode) {
        return code === codeOrCollection;
    }
    return collection === codeOrCollection;
};
var getProductAttribute = function(attributes, codeOrCollection) {
    var matchingAttribute = attributes === null || attributes === void 0 ? void 0 : attributes.find(function(a) {
        return filterAttributesByCodeOrCollection(a, codeOrCollection);
    });
    if (matchingAttribute) {
        return parseAttribute(matchingAttribute);
    }
    return null;
};
var ref;
var getMultipleProductAttributes = function(attributes, codeOrCollection) {
    return (ref = attributes === null || attributes === void 0 ? void 0 : attributes.filter(function(a) {
        return filterAttributesByCodeOrCollection(a, codeOrCollection);
    }).map(function(attribute) {
        return parseAttribute(attribute);
    })) !== null && ref !== void 0 ? ref : [];
};


/***/ }),

/***/ 56987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ DictionaryCode; },
/* harmony export */   "v": function() { return /* binding */ DictionaryTitlesCode; }
/* harmony export */ });
var DictionaryCode;
(function(DictionaryCode) {
    DictionaryCode["ApplicationTimes"] = "application-times";
    DictionaryCode["AreaOfInjection"] = "area-of-injection";
    DictionaryCode["BeautyRoutines"] = "beauty-routines";
    DictionaryCode["Common"] = "common";
    DictionaryCode["CommonFillers"] = "common-fillers";
    DictionaryCode["Durations"] = "durations";
    DictionaryCode["ExtrusionForces"] = "extrusion-forces";
    DictionaryCode["HaConcentrations"] = "ha-concentrations";
    DictionaryCode["Icons"] = "icons";
    DictionaryCode["Ingredients"] = "ingredients";
    DictionaryCode["InjectionPlaces"] = "injection-places";
    DictionaryCode["InjectionTools"] = "injection-tools";
    DictionaryCode["LegalMentions"] = "legal-mentions";
    DictionaryCode["Titles"] = "titles";
    DictionaryCode["TreatmentEssentials"] = "treatment-essentials";
    DictionaryCode["Volumes"] = "volumes";
})(DictionaryCode || (DictionaryCode = {}));
var DictionaryTitlesCode;
(function(DictionaryTitlesCode) {
    DictionaryTitlesCode["Volume"] = "volume";
    DictionaryTitlesCode["KeyActiveIngredients"] = "key-active-ingredients";
    DictionaryTitlesCode["Application"] = "application";
    DictionaryTitlesCode["BeautyTip"] = "beauty-tip";
    DictionaryTitlesCode["HaConcentration"] = "ha-concentration";
    DictionaryTitlesCode["Contains"] = "contains";
    DictionaryTitlesCode["AreaOfInjection"] = "area-of-injection";
    DictionaryTitlesCode["WhatIsNboost"] = "what-is-nboost";
    DictionaryTitlesCode["KeyBenefits"] = "key-beneftis";
    DictionaryTitlesCode["ProductFeatures"] = "product-features";
    DictionaryTitlesCode["Sct"] = "sct";
    DictionaryTitlesCode["FillersCrossSellingTitle"] = "fillers-cross-selling-title";
    DictionaryTitlesCode["Duration"] = "duration";
    DictionaryTitlesCode["ExtrusionForce"] = "extrusion-force";
    DictionaryTitlesCode["Stiffness"] = "stiffness";
    DictionaryTitlesCode["HowItWorks"] = "how-it-works";
    DictionaryTitlesCode["Results"] = "results";
    DictionaryTitlesCode["TechnicalFeatures"] = "technical-features";
    DictionaryTitlesCode["DevicesCrossSellingTitle"] = "devices-cross-selling-title";
    DictionaryTitlesCode["AestheticIndications"] = "aesthetic-indications";
    DictionaryTitlesCode["ScienceBehind"] = "science-behind";
    DictionaryTitlesCode["RoutineBanner"] = "routine-banner";
    DictionaryTitlesCode["CosmeceuticalsCrossSellingTitle"] = "cosmeceuticals-cross-selling-title";
    DictionaryTitlesCode["IngredientsList"] = "ingredients-list";
    DictionaryTitlesCode["InjectionPlace"] = "injection-place";
    DictionaryTitlesCode["InjectionTool"] = "injection-recommended-with";
    DictionaryTitlesCode["Downloads"] = "downloads";
    DictionaryTitlesCode["DownloadsSubtitle"] = "downloads-subtitle";
})(DictionaryTitlesCode || (DictionaryTitlesCode = {}));


/***/ }),

/***/ 52178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ GenericSectionHeader; },
/* harmony export */   "W": function() { return /* binding */ NavigationButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var src_components_common_typography_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29894);
/* harmony import */ var vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15201);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78296);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68251);
/* harmony import */ var src_modules_materials_providers_ShowcaseContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54095);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from, 99% {\n    pointer-events: all;\n  }\n  to {\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    position: absolute;\n    z-index: 3;\n    margin: 15.25px;\n    top: calc(43.55px - 15.25px + 1rpx);\n    background: rgba(0, 0, 0, 0.15);\n    backdrop-filter: blur(8px);\n    border-radius: 50%;\n\n    ",
        ": 0;\n    ",
        " {\n      ",
        ": auto;\n      ",
        ": 0;\n    }\n\n    .swiper:not(.swiper-initialized) {\n      opacity: 0 !important;\n    }\n\n    &[disabled],\n    &.hidden {\n      opacity: 0 !important;\n      animation: ",
        " 1s linear forwards;\n    }\n\n    &:not(:focus) .btn__content:before {\n      border-color: transparent !important;\n    }\n\n    .btn__content svg {\n      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.3));\n    }\n\n    ",
        " {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var GenericSectionHeader = function(param) {
    var section = param.section;
    var ref = (0,react_t7e__WEBPACK_IMPORTED_MODULE_9__.useTranslate)(), _ = ref._, _n = ref._n;
    var itemsToQuery = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(src_modules_materials_providers_ShowcaseContext__WEBPACK_IMPORTED_MODULE_8__/* .ShowcaseContext */ .r).itemsToQuery;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_common_typography_Header__WEBPACK_IMPORTED_MODULE_2__/* .H1Smaller */ .B, {
        as: "h2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_3__/* .Markdown */ .U, {
                children: _(section.name)
            }),
            section.count !== undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_3__/* .Markdown */ .U, {
                        children: itemsToQuery.includes("materials") ? _n("({count} Item)", "({count} Items)", section.count, undefined, {
                            count: section.count
                        }) : _n("({count} Video)", "({count} Videos)", section.count, undefined, {
                            count: section.count
                        })
                    })
                ]
            }) : null
        ]
    });
};
var disableLater = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__.keyframes)(_templateObject());
var NavigationButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx).withConfig({
    displayName: "common__NavigationButton",
    componentId: "sc-268bbdd6-0"
})(_templateObject1(), function(param) {
    var $direction = param.$direction;
    return $direction;
}, src_styles_theme__WEBPACK_IMPORTED_MODULE_7__/* .dirRTL */ .gX, function(param) {
    var $direction = param.$direction;
    return $direction;
}, function(param) {
    var $direction = param.$direction;
    return $direction === "left" ? "right" : "left";
}, disableLater, src_styles_designs__WEBPACK_IMPORTED_MODULE_6__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop);


/***/ }),

/***/ 54095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ShowcaseContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ShowcaseContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    itemsToQuery: [
        "materials",
        "videos"
    ]
});


/***/ }),

/***/ 1036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ ProductLogo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/modules/products/assets/nrose.svg




function SvgNrose(props, svgRef) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 128.361 40.84",
        ref: svgRef
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "nrose_svg__a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        d: "M0 0h128.361v40.84H0z"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#fff",
                clipPath: "url(#nrose_svg__a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M33.9 29.742L12.34 3.621C10.48 1.372 8.011 0 4 0H0v1.192h.61c4.316 0 5.547 2.429 5.547 6.021v33.058h2.466V8.114l26.529 32.161h1.236V0H33.9zM59.627 28.645c-1.042 0-1.7-.348-1.7-1.081 0-.772.5-1.119.5-2.2a1.181 1.181 0 00-1.35-1.274c-1.891 0-4.014 3.087-4.014 6.56v9.111h3.357v.541h-9.645v-.541h2.971V24.285h-2.971v-.54h6.213v3.9h.077c.733-2.508 2.509-4.322 5.056-4.322a3.166 3.166 0 013.435 3.2c0 1.582-.85 2.123-1.93 2.123M76.03 40.84a9.172 9.172 0 01-8.991-8.8c0-4.9 4.631-8.8 8.991-8.8 4.4 0 8.992 3.936 8.992 8.8 0 4.785-4.4 8.8-8.992 8.8m5.133-8.8c0-5.711-1.35-8.258-5.171-8.258s-5.094 2.778-5.094 8.1c0 7.6 2.431 8.413 5.248 8.413 3.743 0 5.017-2.662 5.017-8.258M102.967 23.745h.425v4.4h-.425c-.926-3.164-2.276-4.36-4.322-4.36-2.47 0-3.9 1.2-3.9 3.125 0 1.466 1.119 2.2 2.817 2.779 1.157.386 2.508.81 3.781 1.235 1.66.579 3.782 1.891 3.782 4.438 0 3.048-2.47 5.48-6.136 5.48-2.2 0-3.782-1.081-4.9-1.081a.913.913 0 00-.926.54h-.424v-5.4h.424c1.081 3.705 3.126 5.4 6.059 5.4a2.973 2.973 0 003.2-3.2c0-1.814-1-2.509-2.47-3.01-.926-.309-2.161-.733-3.164-1.081-2.045-.694-3.705-1.7-3.705-4.669 0-2.894 2.316-5.094 5.557-5.094 2.122 0 2.7.81 3.7.81a.657.657 0 00.617-.309M116.476 30.729c-.039.849-.039 1.621-.039 2.354 0 5.056 1.93 7.217 5.094 7.217 3.01 0 5.056-1.312 5.943-4.361l.579.116c-.811 2.971-2.971 4.785-6.56 4.785-5.21 0-8.914-3.512-8.914-8.721a8.952 8.952 0 018.606-8.875c3.666 0 7.178 2.469 7.178 7.486zm7.949-.54c.039-.618.077-1.274.077-1.891 0-3.858-1.7-4.514-3.28-4.514-3.241 0-4.437 2.315-4.708 6.406z"
                })
            })
        ]
    }));
}
var ForwardRef = /*#__PURE__*/ react.forwardRef(SvgNrose);
var MemoForwardRef = /*#__PURE__*/ react.memo(ForwardRef);
/* harmony default export */ var nrose = (MemoForwardRef);

;// CONCATENATED MODULE: ./src/modules/products/assets/nboost.svg




function SvgNboost(props, svgRef) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 142.299 40.84",
        ref: svgRef
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "nboost_svg__a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        d: "M0 0h142.299v40.84H0z"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#fff",
                clipPath: "url(#nboost_svg__a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M34.383 29.984L12.516 3.65C10.628 1.383 8.126 0 4.058 0H.001v1.2h.618c4.376 0 5.626 2.448 5.626 6.07V40.6h2.5V8.18L35.649 40.6h1.252V0h-2.518zM133.22 21.169h-3.329v.476h3.329v13.1c0 4.194 1.3 6.1 4.583 6.1a4.264 4.264 0 004.5-3.372l-.476-.13c-.778 2.508-2.378 2.81-3.026 2.81-.864 0-1.253-.3-1.253-1.9v-16.6h4.323v-.476h-4.323v-7.79a4.346 4.346 0 01-3.459 2.378 2.944 2.944 0 01-.864-.086zm-19.541 18.85h.346a.994.994 0 01.952-.519c.95 0 3.156 1.34 5.533 1.34 4.15 0 7.479-2.983 7.479-6.4 0-2.767-1.859-3.718-5.62-5.62-3.8-1.945-5.058-2.983-5.058-5.015 0-2.465 2.335-2.983 3.5-2.983 1.772 0 4.193.95 4.885 4.885h.345v-4.54h-.345a.866.866 0 01-.692.26 3.785 3.785 0 01-1.512-.476 7.12 7.12 0 00-2.768-.605 5.629 5.629 0 00-5.794 5.707c0 3.891 2.465 5.015 5.232 6.355 3.588 1.729 5.1 2.464 5.1 4.41 0 1.816-1.471 3.545-4.583 3.545a5.5 5.5 0 01-4.237-1.773c-1.469-1.383-1.9-2.767-2.421-4.842h-.346zM96.56 30.594c0-6.182.259-9.77 4.713-9.77 4.669 0 4.669 3.761 4.669 9.77s-.13 9.771-4.669 9.771c-4.583 0-4.713-3.588-4.713-9.771m-4.843 0c0 6.053 5.232 10.247 9.555 10.247s9.51-4.15 9.51-10.247-5.187-10.246-9.51-10.246c-4.194 0-9.555 4.194-9.555 10.246m-17.941 0c0-6.182.259-9.77 4.712-9.77 4.669 0 4.669 3.761 4.669 9.77s-.129 9.771-4.669 9.771c-4.583 0-4.712-3.588-4.712-9.771m-4.842 0c0 6.053 5.231 10.247 9.555 10.247s9.512-4.15 9.512-10.247-5.189-10.246-9.512-10.246c-4.194 0-9.555 4.194-9.555 10.246m-17.336-.259c0-5.361.043-6.831 1.643-8.3a4.611 4.611 0 013.113-1.21c3.977 0 4.194 4.107 4.194 8.949 0 7-.39 10.246-4.108 10.246a4.331 4.331 0 01-3.891-2.291c-.822-1.34-.951-3.545-.951-7.392m-3.977 9.208h-3.114v.475h7.437v-2.379a4.935 4.935 0 004.539 2.854c4.107 0 8.906-4.194 8.906-10.074 0-6.009-5.058-10.073-8.993-10.073a4.949 4.949 0 00-4.452 2.551v-14.7h-7.437v.475h3.113z"
                })
            })
        ]
    }));
}
var nboost_ForwardRef = /*#__PURE__*/ react.forwardRef(SvgNboost);
var nboost_MemoForwardRef = /*#__PURE__*/ react.memo(nboost_ForwardRef);
/* harmony default export */ var nboost = (nboost_MemoForwardRef);

;// CONCATENATED MODULE: ./src/modules/products/assets/nlift.svg




function SvgNlift(props, svgRef) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 105.099 40.84",
        ref: svgRef
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "nlift_svg__a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        d: "M0 0h105.099v40.84H0z"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M43.82 8.32v.62h3.407v30.661H43.82v.62h10.619v-.62h-3.408V8.32z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#fff",
                clipPath: "url(#nlift_svg__a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M62.007 10.931a2.341 2.341 0 11.686 1.659 2.256 2.256 0 01-.686-1.659m-2.876 28.67h3.407V21.859h-3.407v-.619h7.212v18.361h3.407v.619H59.129zM74.439 39.601h3.4V21.859h-3.4v-.619h3.4v-2.345a20.025 20.025 0 01.155-2.678 12.834 12.834 0 01.42-1.991 7.957 7.957 0 01.62-1.5 7.408 7.408 0 01.8-1.172 11.218 11.218 0 012.876-2.543 6.784 6.784 0 013.672-1.084 6.669 6.669 0 012.5.421 5.5 5.5 0 011.7 1.039 4.007 4.007 0 01.973 1.35 3.419 3.419 0 01.309 1.3 2.664 2.664 0 01-.487 1.548 1.841 1.841 0 01-1.636.708 3.873 3.873 0 01-1.302-.267 1.1 1.1 0 01-.73-1.15 2.282 2.282 0 01.421-1.349 2.3 2.3 0 00.42-1.349 1.277 1.277 0 00-.8-1.3 4.221 4.221 0 00-1.638-.332 3.982 3.982 0 00-3.141 1.592 7.659 7.659 0 00-1.326 4.956v6.151h5.494v.619h-5.486v17.737h4.026v.619h-11.24zM90.896 21.24h3.407v-5.708q.354.133.663.221a4.367 4.367 0 001.062.089 3.814 3.814 0 001.151-.155 2.883 2.883 0 00.929-.509v6.061h6.283v.619h-6.283v14.47a6.852 6.852 0 00.243 2.013 3.021 3.021 0 00.642 1.194 1.905 1.905 0 00.863.553 3.257 3.257 0 00.906.134 3.113 3.113 0 002.5-1.129 5.462 5.462 0 001.217-2.589l.62.221a10.259 10.259 0 01-.4 1.283 4.477 4.477 0 01-.818 1.349 4.3 4.3 0 01-1.438 1.062 5.158 5.158 0 01-2.213.42q-3.317 0-4.623-1.283a4.856 4.856 0 01-1.3-3.628V21.859H90.9zM33.92 29.756L12.347 3.622C10.485 1.372 8.016 0 4 0H0v1.192h.61c4.318 0 5.551 2.43 5.551 6.024V40.29h2.466V8.117L35.17 40.293h1.236V0H33.92z"
                })
            })
        ]
    }));
}
var nlift_ForwardRef = /*#__PURE__*/ react.forwardRef(SvgNlift);
var nlift_MemoForwardRef = /*#__PURE__*/ react.memo(nlift_ForwardRef);
/* harmony default export */ var nlift = (nlift_MemoForwardRef);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductLogo.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 160px;\n      height: 60px;\n\n      ",
        " {\n        width: 210px;\n        height: 83px;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 42px;\n  color: ",
        ";\n\n  width: auto;\n  height: 36px;\n\n  svg {\n    width: auto;\n    height: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var codeLogoMap = {
    nrose: nrose,
    nboost: nboost,
    nlift: nlift
};
var Heading = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "ProductLogo__Heading",
    componentId: "sc-85b1a00b-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, function(param) {
    var $size = param.$size;
    return $size === "big" && (0,styled_components_browser_esm.css)(_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
});
var ProductLogo = function(param) {
    var name = param.name, code = param.code, _size = param.size, size = _size === void 0 ? "default" : _size;
    var Logo = codeLogoMap[code];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
        $size: size,
        children: Logo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {}) : name !== null && name !== void 0 ? name : code
    });
};


/***/ }),

/***/ 35361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ProductPageBenefitsSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87379);
/* harmony import */ var src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70057);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71008);
/* harmony import */ var src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38108);
/* harmony import */ var vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15201);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var src_components_common_Heading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79557);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73098);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var src_modules_products_hooks_useProductAttributes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50999);
/* harmony import */ var src_modules_products_hooks_useTitlesDictionary__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76249);
/* harmony import */ var src_components_common_typography_Text__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51306);
/* harmony import */ var src_components_common_StickyMenu_StickyMenuSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(226);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 32px 0 48px;\n  background: ",
        ";\n\n  & + & {\n    padding-top: 0;\n  }\n\n  ",
        " {\n    padding: 58px 0;\n\n    & + & {\n      padding-top: 16px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 21px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n\n  ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 21px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: 16px 1fr;\n  gap: 12px;\n\n  padding: 16px 0;\n\n  border-top: 1rpx solid ",
        ";\n  color: ",
        ";\n\n  & > svg {\n    margin-top: 4px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  font-size: 18px;\n  text-transform: uppercase;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 540px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














var Section = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__["default"])(src_components_common_StickyMenu_StickyMenuSection__WEBPACK_IMPORTED_MODULE_13__/* .StickyMenuSection */ .T).withConfig({
    displayName: "ProductPageBenefitsSection__Section",
    componentId: "sc-687b378a-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_8__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ListContainer = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].ul.withConfig({
    displayName: "ProductPageBenefitsSection__ListContainer",
    componentId: "sc-687b378a-1"
})(_templateObject1());
var ListInnerContainer = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].div.withConfig({
    displayName: "ProductPageBenefitsSection__ListInnerContainer",
    componentId: "sc-687b378a-2"
})(_templateObject2(), src_styles_designs__WEBPACK_IMPORTED_MODULE_8__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].li.withConfig({
    displayName: "ProductPageBenefitsSection__ListItem",
    componentId: "sc-687b378a-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.skeleton.base;
}, function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var Label = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].h3.withConfig({
    displayName: "ProductPageBenefitsSection__Label",
    componentId: "sc-687b378a-4"
})(_templateObject4());
var Description = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__["default"])(src_components_common_typography_Text__WEBPACK_IMPORTED_MODULE_12__/* .Paragraph */ .n).withConfig({
    displayName: "ProductPageBenefitsSection__Description",
    componentId: "sc-687b378a-5"
})(_templateObject5());
var ProductPageBenefitsSection = function(param) {
    var product = param.product, titleCode = param.titleCode, textCode = param.textCode, dictionaryTitleCode = param.dictionaryTitleCode, descriptionCode = param.descriptionCode;
    var translateFn = (0,src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_2__/* .useTranslateItem */ .L)();
    var getProductAttribute = (0,src_modules_products_hooks_useProductAttributes__WEBPACK_IMPORTED_MODULE_10__/* .useProductAttributes */ .g)(product.attributes).getProductAttribute;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,src_modules_products_hooks_useTitlesDictionary__WEBPACK_IMPORTED_MODULE_11__/* .useTitlesDictionary */ .L)(dictionaryTitleCode), 1), dictionaryTitle = ref[0];
    var ref1;
    var title = (ref1 = (0,lodash__WEBPACK_IMPORTED_MODULE_9__.head)(getProductAttribute(titleCode))) !== null && ref1 !== void 0 ? ref1 : dictionaryTitle;
    var description = (0,lodash__WEBPACK_IMPORTED_MODULE_9__.head)(getProductAttribute(descriptionCode));
    var list = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var benefitsAttribute = (0,lodash__WEBPACK_IMPORTED_MODULE_9__.head)(getProductAttribute(textCode));
        if (benefitsAttribute) {
            var titles = translateFn(benefitsAttribute).value.split("###").filter(Boolean);
            var ref;
            return titles.map(function(text) {
                var ref1, ref2;
                return {
                    label: text.startsWith("-") ? "" : (ref1 = text.split("\n")) === null || ref1 === void 0 ? void 0 : ref1[0],
                    items: (ref = (ref2 = text.match(/^(?:\d+\.|[*+-]) .*/gm)) === null || ref2 === void 0 ? void 0 : ref2.map(function(v) {
                        return v.slice(2);
                    })) !== null && ref !== void 0 ? ref : []
                };
            });
        }
        return [];
    }, [
        textCode,
        getProductAttribute,
        translateFn
    ]);
    if (!title || list.length === 0 && !description) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Section, {
        id: "benefits",
        label: translateFn(title).value,
        threshold: {
            desktop: 1,
            mobile: 0.8
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_3__/* .ConstraintContainer */ .a, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Heading__WEBPACK_IMPORTED_MODULE_7__/* .Heading */ .X, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_5__/* .Markdown */ .U, {
                        children: translateFn(title).value
                    })
                }),
                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Description, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_5__/* .Markdown */ .U, {
                        children: translateFn(description).value
                    })
                }),
                list.map(function(param, index) {
                    var label = param.label, items = param.items;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListContainer, {
                        children: [
                            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                                children: label
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListInnerContainer, {
                                children: items.map(function(text) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListItem, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_4__/* .ChevronRight */ ._, {
                                                size: 14
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_typography_Text__WEBPACK_IMPORTED_MODULE_12__/* .Paragraph */ .n, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_5__/* .Markdown */ .U, {
                                                    children: text
                                                })
                                            })
                                        ]
                                    }, text);
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};


/***/ }),

/***/ 42768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ ProductPageLegalMentions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
// EXTERNAL MODULE: ./src/components/common/typography/Text.tsx
var Text = __webpack_require__(51306);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./src/modules/products/hooks/useDictionaryDetailsQuery.ts
var useDictionaryDetailsQuery = __webpack_require__(64308);
;// CONCATENATED MODULE: ./src/modules/products/hooks/useDictionary.ts


var useDictionary = function(code) {
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var ref = (0,useDictionaryDetailsQuery/* useDictionaryDetailsQuery */.F)(code), dictionary = ref.data;
    var ref1;
    return (ref1 = dictionary === null || dictionary === void 0 ? void 0 : dictionary.entries.map(translateFn)) !== null && ref1 !== void 0 ? ref1 : [];
};

// EXTERNAL MODULE: ./src/models/pim/dictionaries.ts
var dictionaries = __webpack_require__(56987);
// EXTERNAL MODULE: ./src/modules/products/hooks/useProductAttributes.ts
var useProductAttributes = __webpack_require__(50999);
// EXTERNAL MODULE: ./src/models/pim/attributes.ts
var attributes = __webpack_require__(74822);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/markdown-to-jsx/dist/index.modern.js
function n(){return n=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r])}return t},n.apply(this,arguments)}const e=["children","options"],r=["allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","cellPadding","cellSpacing","charSet","className","classId","colSpan","contentEditable","contextMenu","crossOrigin","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hrefLang","inputMode","keyParams","keyType","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","radioGroup","readOnly","rowSpan","spellCheck","srcDoc","srcLang","srcSet","tabIndex","useMap"].reduce((t,n)=>(t[n.toLowerCase()]=n,t),{for:"htmlFor"}),o={amp:"&",apos:"'",gt:">",lt:"<",nbsp:" ",quot:"“"},c=["style","script"],a=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,_=/mailto:/i,u=/\n{2,}$/,i=/^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,l=/^ *> ?/gm,s=/^ {2,}\n/,f=/^(?:( *[-*_])){3,} *(?:\n *)+\n/,d=/^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/,p=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,m=/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,g=/^(?:\n *)*\n/,y=/\r\n?/g,h=/^\[\^([^\]]+)](:.*)\n/,k=/^\[\^([^\]]+)]/,x=/\f/g,b=/^\s*?\[(x|\s)\]/,v=/^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,$=/^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,S=/^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i,z=/&([a-zA-Z]+);/g,w=/^<!--[\s\S]*?(?:-->)/,A=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,E=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,L=/^\{.*\}$/,M=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,I=/^<([^ >]+@[^ >]+)>/,O=/^<([^ >]+:\/[^ >]+)>/,B=/-([a-z])?/gi,R=/^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,T=/^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/,j=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,C=/^\[([^\]]*)\] ?\[([^\]]*)\]/,D=/(\[|\])/g,N=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,Z=/\t/g,F=/^ *\| */,P=/(^ *\||\| *$)/g,G=/ *$/,H=/^ *:-+: *$/,q=/^ *:-+ *$/,U=/^ *-+: *$/,V=/^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,W=/^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/,Q=/^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/,X=/^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,J=/^\\([^0-9A-Za-z\s])/,K=/^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,Y=/^\n+/,tt=/^([ \t]*)/,nt=/\\([^\\])/g,et=/ *\n+$/,rt=/(?:^|\n)( *)$/,ot="(?:\\d+\\.)",ct="(?:[*+-])";function at(t){return"( *)("+(1===t?ot:ct)+") +"}const _t=at(1),ut=at(2);function it(t){return new RegExp("^"+(1===t?_t:ut))}const lt=it(1),st=it(2);function ft(t){return new RegExp("^"+(1===t?_t:ut)+"[^\\n]*(?:\\n(?!\\1"+(1===t?ot:ct)+" )[^\\n]*)*(\\n|$)","gm")}const dt=ft(1),pt=ft(2);function mt(t){const n=1===t?ot:ct;return new RegExp("^( *)("+n+") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1"+n+" (?!"+n+" ))\\n*|\\s*\\n*$)")}const gt=mt(1),yt=mt(2);function ht(t,n){const e=1===n,r=e?gt:yt,o=e?dt:pt,c=e?lt:st;return{t(t,n,e){const o=rt.exec(e);return o&&(n.o||!n._&&!n.u)?r.exec(t=o[1]+t):null},i:Gt.HIGH,l(t,n,r){const a=e?+t[2]:void 0,_=t[0].replace(u,"\n").match(o);let i=!1;return{p:_.map(function(t,e){const o=c.exec(t)[0].length,a=new RegExp("^ {1,"+o+"}","gm"),u=t.replace(a,"").replace(c,""),l=e===_.length-1,s=-1!==u.indexOf("\n\n")||l&&i;i=s;const f=r._,d=r.o;let p;r.o=!0,s?(r._=!1,p=u.replace(et,"\n\n")):(r._=!0,p=u.replace(et,""));const m=n(p,r);return r._=f,r.o=d,m}),m:e,g:a}},h:(n,e,r)=>t(n.m?"ol":"ul",{key:r.k,start:n.g},n.p.map(function(n,o){return t("li",{key:o},e(n,r))}))}}const kt=/^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/,xt=/^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/,bt=[i,d,p,v,$,w,R,dt,gt,pt,yt],vt=[...bt,/^[^\n]+(?:  \n|\n{2,})/,S,E];function $t(t){return t.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,"a").replace(/[çÇ]/g,"c").replace(/[ðÐ]/g,"d").replace(/[ÈÉÊËéèêë]/g,"e").replace(/[ÏïÎîÍíÌì]/g,"i").replace(/[Ññ]/g,"n").replace(/[øØœŒÕõÔôÓóÒò]/g,"o").replace(/[ÜüÛûÚúÙù]/g,"u").replace(/[ŸÿÝý]/g,"y").replace(/[^a-z0-9- ]/gi,"").replace(/ /gi,"-").toLowerCase()}function St(t){return U.test(t)?"right":H.test(t)?"center":q.test(t)?"left":null}function zt(t,n,e){const r=e.v;e.v=!0;const o=n(t.trim(),e);e.v=r;let c=[[]];return o.forEach(function(t,n){"tableSeparator"===t.type?0!==n&&n!==o.length-1&&c.push([]):("text"!==t.type||null!=o[n+1]&&"tableSeparator"!==o[n+1].type||(t.$=t.$.replace(G,"")),c[c.length-1].push(t))}),c}function wt(t,n,e){e._=!0;const r=zt(t[1],n,e),o=t[2].replace(P,"").split("|").map(St),c=function(t,n,e){return t.trim().split("\n").map(function(t){return zt(t,n,e)})}(t[3],n,e);return e._=!1,{S:o,A:c,L:r,type:"table"}}function At(t,n){return null==t.S[n]?{}:{textAlign:t.S[n]}}function Et(t){return function(n,e){return e._?t.exec(n):null}}function Lt(t){return function(n,e){return e._||e.u?t.exec(n):null}}function Mt(t){return function(n,e){return e._||e.u?null:t.exec(n)}}function It(t){return function(n){return t.exec(n)}}function Ot(t,n,e){if(n._||n.u)return null;if(e&&!e.endsWith("\n"))return null;let r="";t.split("\n").every(t=>!bt.some(n=>n.test(t))&&(r+=t+"\n",t.trim()));const o=r.trimEnd();return""==o?null:[r,o]}function Bt(t){try{if(decodeURIComponent(t).replace(/[^A-Za-z0-9/:]/g,"").match(/^\s*(javascript|vbscript|data(?!:image)):/i))return null}catch(t){return null}return t}function Rt(t){return t.replace(nt,"$1")}function Tt(t,n,e){const r=e._||!1,o=e.u||!1;e._=!0,e.u=!0;const c=t(n,e);return e._=r,e.u=o,c}function jt(t,n,e){const r=e._||!1,o=e.u||!1;e._=!1,e.u=!0;const c=t(n,e);return e._=r,e.u=o,c}function Ct(t,n,e){return e._=!1,t(n+"\n\n",e)}const Dt=(t,n,e)=>({$:Tt(n,t[1],e)});function Nt(){return{}}function Zt(){return null}function Ft(...t){return t.filter(Boolean).join(" ")}function Pt(t,n,e){let r=t;const o=n.split(".");for(;o.length&&(r=r[o[0]],void 0!==r);)o.shift();return r||e}var Gt;function Ht(e,u={}){u.overrides=u.overrides||{},u.slugify=u.slugify||$t,u.namedCodesToUnicode=u.namedCodesToUnicode?n({},o,u.namedCodesToUnicode):o;const P=u.createElement||react.createElement;function G(t,e,...r){const o=Pt(u.overrides,`${t}.props`,{});return P(function(t,n){const e=Pt(n,t);return e?"function"==typeof e||"object"==typeof e&&"render"in e?e:Pt(n,`${t}.component`,t):t}(t,u.overrides),n({},e,o,{className:Ft(null==e?void 0:e.className,o.className)||void 0}),...r)}function H(n){let e=!1;u.forceInline?e=!0:u.forceBlock||(e=!1===N.test(n));const r=ot(rt(e?n:`${n.trimEnd().replace(Y,"")}\n\n`,{_:e}));for(;"string"==typeof r[r.length-1]&&!r[r.length-1].trim();)r.pop();if(null===u.wrapper)return r;const o=u.wrapper||(e?"span":"div");let c;if(r.length>1||u.forceWrapper)c=r;else{if(1===r.length)return c=r[0],"string"==typeof c?G("span",{key:"outer"},c):c;c=null}return react.createElement(o,{key:"outer"},c)}function q(n){const e=n.match(a);return e?e.reduce(function(n,e,o){const c=e.indexOf("=");if(-1!==c){const a=function(t){return-1!==t.indexOf("-")&&null===t.match(A)&&(t=t.replace(B,function(t,n){return n.toUpperCase()})),t}(e.slice(0,c)).trim(),_=function(t){const n=t[0];return('"'===n||"'"===n)&&t.length>=2&&t[t.length-1]===n?t.slice(1,-1):t}(e.slice(c+1).trim()),u=r[a]||a,i=n[u]=function(t,n){return"style"===t?n.split(/;\s?/).reduce(function(t,n){const e=n.slice(0,n.indexOf(":"));return t[e.replace(/(-[a-z])/g,t=>t[1].toUpperCase())]=n.slice(e.length+1).trim(),t},{}):"href"===t?Bt(n):(n.match(L)&&(n=n.slice(1,n.length-1)),"true"===n||"false"!==n&&n)}(a,_);"string"==typeof i&&(S.test(i)||E.test(i))&&(n[u]=react.cloneElement(H(i.trim()),{key:o}))}else"style"!==e&&(n[r[e]||e]=!0);return n},{}):null}const U=[],nt={},et={blockQuote:{t:Mt(i),i:Gt.HIGH,l:(t,n,e)=>({$:n(t[0].replace(l,""),e)}),h:(t,n,e)=>G("blockquote",{key:e.k},n(t.$,e))},breakLine:{t:It(s),i:Gt.HIGH,l:Nt,h:(t,n,e)=>G("br",{key:e.k})},breakThematic:{t:Mt(f),i:Gt.HIGH,l:Nt,h:(t,n,e)=>G("hr",{key:e.k})},codeBlock:{t:Mt(p),i:Gt.MAX,l:t=>({$:t[0].replace(/^ {4}/gm,"").replace(/\n+$/,""),M:void 0}),h:(t,e,r)=>G("pre",{key:r.k},G("code",n({},t.I,{className:t.M?`lang-${t.M}`:""}),t.$))},codeFenced:{t:Mt(d),i:Gt.MAX,l:t=>({I:q(t[3]||""),$:t[4],M:t[2]||void 0,type:"codeBlock"})},codeInline:{t:Lt(m),i:Gt.LOW,l:t=>({$:t[2]}),h:(t,n,e)=>G("code",{key:e.k},t.$)},footnote:{t:Mt(h),i:Gt.MAX,l:t=>(U.push({O:t[2],B:t[1]}),{}),h:Zt},footnoteReference:{t:Et(k),i:Gt.HIGH,l:t=>({$:t[1],R:`#${u.slugify(t[1])}`}),h:(t,n,e)=>G("a",{key:e.k,href:Bt(t.R)},G("sup",{key:e.k},t.$))},gfmTask:{t:Et(b),i:Gt.HIGH,l:t=>({T:"x"===t[1].toLowerCase()}),h:(t,n,e)=>G("input",{checked:t.T,key:e.k,readOnly:!0,type:"checkbox"})},heading:{t:Mt(v),i:Gt.HIGH,l:(t,n,e)=>({$:Tt(n,t[2],e),j:u.slugify(t[2]),C:t[1].length}),h:(t,n,e)=>G(`h${t.C}`,{id:t.j,key:e.k},n(t.$,e))},headingSetext:{t:Mt($),i:Gt.MAX,l:(t,n,e)=>({$:Tt(n,t[1],e),C:"="===t[2]?1:2,type:"heading"})},htmlComment:{t:It(w),i:Gt.HIGH,l:()=>({}),h:Zt},image:{t:Lt(xt),i:Gt.HIGH,l:t=>({D:t[1],R:Rt(t[2]),N:t[3]}),h:(t,n,e)=>G("img",{key:e.k,alt:t.D||void 0,title:t.N||void 0,src:Bt(t.R)})},link:{t:Et(kt),i:Gt.LOW,l:(t,n,e)=>({$:jt(n,t[1],e),R:Rt(t[2]),N:t[3]}),h:(t,n,e)=>G("a",{key:e.k,href:Bt(t.R),title:t.N},n(t.$,e))},linkAngleBraceStyleDetector:{t:Et(O),i:Gt.MAX,l:t=>({$:[{$:t[1],type:"text"}],R:t[1],type:"link"})},linkBareUrlDetector:{t:(t,n)=>n.Z?null:Et(M)(t,n),i:Gt.MAX,l:t=>({$:[{$:t[1],type:"text"}],R:t[1],N:void 0,type:"link"})},linkMailtoDetector:{t:Et(I),i:Gt.MAX,l(t){let n=t[1],e=t[1];return _.test(e)||(e="mailto:"+e),{$:[{$:n.replace("mailto:",""),type:"text"}],R:e,type:"link"}}},orderedList:ht(G,1),unorderedList:ht(G,2),newlineCoalescer:{t:Mt(g),i:Gt.LOW,l:Nt,h:()=>"\n"},paragraph:{t:Ot,i:Gt.LOW,l:Dt,h:(t,n,e)=>G("p",{key:e.k},n(t.$,e))},ref:{t:Et(T),i:Gt.MAX,l:t=>(nt[t[1]]={R:t[2],N:t[4]},{}),h:Zt},refImage:{t:Lt(j),i:Gt.MAX,l:t=>({D:t[1]||void 0,F:t[2]}),h:(t,n,e)=>G("img",{key:e.k,alt:t.D,src:Bt(nt[t.F].R),title:nt[t.F].N})},refLink:{t:Et(C),i:Gt.MAX,l:(t,n,e)=>({$:n(t[1],e),P:n(t[0].replace(D,"\\$1"),e),F:t[2]}),h:(t,n,e)=>nt[t.F]?G("a",{key:e.k,href:Bt(nt[t.F].R),title:nt[t.F].N},n(t.$,e)):G("span",{key:e.k},n(t.P,e))},table:{t:Mt(R),i:Gt.HIGH,l:wt,h:(t,n,e)=>G("table",{key:e.k},G("thead",null,G("tr",null,t.L.map(function(r,o){return G("th",{key:o,style:At(t,o)},n(r,e))}))),G("tbody",null,t.A.map(function(r,o){return G("tr",{key:o},r.map(function(r,o){return G("td",{key:o,style:At(t,o)},n(r,e))}))})))},tableSeparator:{t:function(t,n){return n.v?F.exec(t):null},i:Gt.HIGH,l:function(){return{type:"tableSeparator"}},h:()=>" | "},text:{t:It(K),i:Gt.MIN,l:t=>({$:t[0].replace(z,(t,n)=>u.namedCodesToUnicode[n]?u.namedCodesToUnicode[n]:t)}),h:t=>t.$},textBolded:{t:Lt(V),i:Gt.MED,l:(t,n,e)=>({$:n(t[2],e)}),h:(t,n,e)=>G("strong",{key:e.k},n(t.$,e))},textEmphasized:{t:Lt(W),i:Gt.LOW,l:(t,n,e)=>({$:n(t[2],e)}),h:(t,n,e)=>G("em",{key:e.k},n(t.$,e))},textEscaped:{t:Lt(J),i:Gt.HIGH,l:t=>({$:t[1],type:"text"})},textMarked:{t:Lt(Q),i:Gt.LOW,l:Dt,h:(t,n,e)=>G("mark",{key:e.k},n(t.$,e))},textStrikethroughed:{t:Lt(X),i:Gt.LOW,l:Dt,h:(t,n,e)=>G("del",{key:e.k},n(t.$,e))}};!0!==u.disableParsingRawHTML&&(et.htmlBlock={t:It(S),i:Gt.HIGH,l(t,n,e){const[,r]=t[3].match(tt),o=new RegExp(`^${r}`,"gm"),a=t[3].replace(o,""),_=(u=a,vt.some(t=>t.test(u))?Ct:Tt);var u;const i=t[1].toLowerCase(),l=-1!==c.indexOf(i);e.Z=e.Z||"a"===i;const s=l?t[3]:_(n,a,e);return e.Z=!1,{I:q(t[2]),$:s,G:l,H:l?i:t[1]}},h:(t,e,r)=>G(t.H,n({key:r.k},t.I),t.G?t.$:e(t.$,r))},et.htmlSelfClosing={t:It(E),i:Gt.HIGH,l:t=>({I:q(t[2]||""),H:t[1]}),h:(t,e,r)=>G(t.H,n({},t.I,{key:r.k}))});const rt=function(t){let n=Object.keys(t);function e(r,o){let c=[],a="";for(;r;){let _=0;for(;_<n.length;){const u=n[_],i=t[u],l=i.t(r,o,a);if(l){const t=l[0];r=r.substring(t.length);const n=i.l(l,e,o);null==n.type&&(n.type=u),c.push(n),a=t;break}_++}}return c}return n.sort(function(n,e){let r=t[n].i,o=t[e].i;return r!==o?r-o:n<e?-1:1}),function(t,n){return e(function(t){return t.replace(y,"\n").replace(x,"").replace(Z,"    ")}(t),n)}}(et),ot=(ct=function(t){return function(n,e,r){return t[n.type].h(n,e,r)}}(et),function t(n,e={}){if(Array.isArray(n)){const r=e.k,o=[];let c=!1;for(let r=0;r<n.length;r++){e.k=r;const a=t(n[r],e),_="string"==typeof a;_&&c?o[o.length-1]+=a:null!==a&&o.push(a),c=_}return e.k=r,o}return ct(n,t,e)});var ct;const at=H(e);return U.length?G("div",null,at,G("footer",{key:"footer"},U.map(function(t){return G("div",{id:u.slugify(t.B),key:t.B},t.B,ot(rt(t.O,{_:!0})))}))):at}!function(t){t[t.MAX=0]="MAX",t[t.HIGH=1]="HIGH",t[t.MED=2]="MED",t[t.LOW=3]="LOW",t[t.MIN=4]="MIN"}(Gt||(Gt={}));/* harmony default export */ var index_modern = (n=>{let{children:r,options:o}=n,c=function(t,n){if(null==t)return{};var e,r,o={},c=Object.keys(t);for(r=0;r<c.length;r++)n.indexOf(e=c[r])>=0||(o[e]=t[e]);return o}(n,e);return react.cloneElement(Ht(r,o),c)});
//# sourceMappingURL=index.modern.js.map

;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageLegalMentions.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: calc(100% + var(--footer-static-height));\n\n    background: #f6f6f6;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 1;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1rpx solid #d6d6d6;\n\n  ",
        " {\n    padding-top: 30px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11px;\n  max-width: 840px;\n  ol {\n    padding-left: 12px;\n    li {\n      list-style: decimal;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageLegalMentions__Container",
    componentId: "sc-3da0b2e3-0"
})(_templateObject());
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageLegalMentions__Content",
    componentId: "sc-3da0b2e3-1"
})(_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Description = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).attrs({
    as: "div"
}).withConfig({
    displayName: "ProductPageLegalMentions__Description",
    componentId: "sc-3da0b2e3-2"
})(_templateObject2());
var ProductPageLegalMentions = function(product) {
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var entries = useDictionary(dictionaries/* DictionaryCode.LegalMentions */.e.LegalMentions);
    var getProductAttribute = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes).getProductAttribute;
    var ref;
    var legalMentions = (ref = (0,lodash.head)(getProductAttribute(attributes/* ProductAttributeCode.LegalMentions */.c.LegalMentions))) !== null && ref !== void 0 ? ref : entries.find(function(entry) {
        var ref;
        return (ref = product.categories) === null || ref === void 0 ? void 0 : ref.some(function(c) {
            return c.categories_code === entry.code;
        });
    });
    if (!legalMentions) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConstraintContainer/* ConstraintContainer */.a, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern, {
                        children: translateFn(legalMentions).value
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 74762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ ProductPageResultsSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71008);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87379);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var src_components_common_Heading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79557);
/* harmony import */ var _hooks_useProductAttributes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50999);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70057);
/* harmony import */ var src_modules_products_hooks_useTitlesDictionary__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76249);
/* harmony import */ var vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15201);
/* harmony import */ var src_components_common_typography_Text__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51306);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12732);
/* harmony import */ var src_components_common_StickyMenu_StickyMenuSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(226);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 32px 0 48px;\n  background: ",
        ";\n\n  ",
        " {\n    padding: 58px 0 82px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n\n  ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 80px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      grid-template-columns: repeat(2, 1fr);\n\n      ",
        " {\n        grid-template-columns: 1fr;\n        gap: 0;\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n\n  ",
        " {\n    gap: 80px;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: min-content 1fr;\n  gap: 20px;\n\n  padding: 20px 0;\n\n  border-top: 1rpx solid ",
        ";\n  text-align: right;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  font-size: 18px;\n  text-transform: uppercase;\n  margin-bottom: 32px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 42px;\n  color: ",
        ";\n  white-space: nowrap;\n  text-align: left;\n  strong {\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}














var Section = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__["default"])(src_components_common_StickyMenu_StickyMenuSection__WEBPACK_IMPORTED_MODULE_13__/* .StickyMenuSection */ .T).withConfig({
    displayName: "ProductPageResultsSection__Section",
    componentId: "sc-ac96dfcd-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ListContainer = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].div.withConfig({
    displayName: "ProductPageResultsSection__ListContainer",
    componentId: "sc-ac96dfcd-1"
})(_templateObject1());
var ListInnerContainer = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].ul.withConfig({
    displayName: "ProductPageResultsSection__ListInnerContainer",
    componentId: "sc-ac96dfcd-2"
})(_templateObject2(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].div.withConfig({
    displayName: "ProductPageResultsSection__Content",
    componentId: "sc-ac96dfcd-3"
})(_templateObject4(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_12__/* .casePathEmptyString */ .Q)("$multiple")((0,styled_components__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject3(), ListInnerContainer)));
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].li.withConfig({
    displayName: "ProductPageResultsSection__ListItem",
    componentId: "sc-ac96dfcd-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.skeleton.base;
});
var Label = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].h3.withConfig({
    displayName: "ProductPageResultsSection__Label",
    componentId: "sc-ac96dfcd-5"
})(_templateObject6());
var Highlight = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].span.withConfig({
    displayName: "ProductPageResultsSection__Highlight",
    componentId: "sc-ac96dfcd-6"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var ProductPageResultsSection = function(param) {
    var product = param.product, titleCode = param.titleCode, dictionaryTitleCode = param.dictionaryTitleCode, textCode = param.textCode;
    var translateFn = (0,src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_8__/* .useTranslateItem */ .L)();
    var getProductAttribute = (0,_hooks_useProductAttributes__WEBPACK_IMPORTED_MODULE_5__/* .useProductAttributes */ .g)(product.attributes).getProductAttribute;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,src_modules_products_hooks_useTitlesDictionary__WEBPACK_IMPORTED_MODULE_9__/* .useTitlesDictionary */ .L)(dictionaryTitleCode), 1), dictionaryTitle = ref[0];
    var ref1;
    var title = (ref1 = (0,lodash__WEBPACK_IMPORTED_MODULE_6__.head)(getProductAttribute(titleCode))) !== null && ref1 !== void 0 ? ref1 : dictionaryTitle;
    var list = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        var resultsAttribute = (0,lodash__WEBPACK_IMPORTED_MODULE_6__.head)(getProductAttribute(textCode));
        if (!resultsAttribute) {
            return [];
        }
        var titles = translateFn(resultsAttribute).value.split("###").filter(Boolean);
        var ref;
        return titles.map(function(text) {
            var ref1, ref2;
            return {
                label: text.startsWith("-") ? "" : (ref1 = text.split("\n")) === null || ref1 === void 0 ? void 0 : ref1[0],
                items: (ref = (ref2 = text.match(/^(?:\d+\.|[*+-]) .*/gm)) === null || ref2 === void 0 ? void 0 : ref2.map(function(v) {
                    var ref;
                    var _$text = v.slice(2);
                    var value = (ref = _$text.match(/\*\*(.+?)\*\*(?!\*)/g)) === null || ref === void 0 ? void 0 : ref[0];
                    return {
                        text: value ? _$text.split(value)[1].trim() || _$text.split(value)[0] : _$text,
                        value: value !== null && value !== void 0 ? value : ""
                    };
                })) !== null && ref !== void 0 ? ref : []
            };
        });
    }, [
        textCode,
        getProductAttribute,
        translateFn
    ]);
    if (list.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Section, {
        id: "results",
        label: title ? translateFn(title).value : undefined,
        threshold: {
            desktop: 0.8,
            mobile: 0.8
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_2__/* .ConstraintContainer */ .a, {
            children: [
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Heading__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_10__/* .Markdown */ .U, {
                        children: translateFn(title).value
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Content, {
                    $multiple: list.length > 1,
                    children: list.map(function(param, index) {
                        var label = param.label, items = param.items;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListContainer, {
                            children: [
                                label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_10__/* .Markdown */ .U, {
                                        children: label
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListInnerContainer, {
                                    children: items.map(function(param) {
                                        var text = param.text, value = param.value;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListItem, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Highlight, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_10__/* .Markdown */ .U, {
                                                        children: value
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_typography_Text__WEBPACK_IMPORTED_MODULE_11__/* .Paragraph */ .n, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_10__/* .Markdown */ .U, {
                                                        children: text
                                                    })
                                                })
                                            ]
                                        }, text + value);
                                    })
                                })
                            ]
                        }, label + index);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 85170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ProductPageSEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_components_seo_MetaDescription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89080);
/* harmony import */ var src_components_seo_MetaTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71508);
/* harmony import */ var src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70057);




var ProductPageSEO = function(_product) {
    var product = (0,src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_3__/* .useTranslateItem */ .L)(_product);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_seo_MetaTitle__WEBPACK_IMPORTED_MODULE_2__/* .MetaTitle */ .p, {
                children: [
                    product.name,
                    product.tagline
                ].filter(Boolean).join(" - ")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_seo_MetaDescription__WEBPACK_IMPORTED_MODULE_1__/* .MetaDescription */ .l, {
                children: product.description_short
            })
        ]
    });
};


/***/ }),

/***/ 11287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductPageSctSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/models/pim/index.ts
var pim = __webpack_require__(82445);
// EXTERNAL MODULE: ./src/models/pim/attributes.ts
var pim_attributes = __webpack_require__(74822);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
// EXTERNAL MODULE: ./src/components/common/Heading.tsx
var Heading = __webpack_require__(79557);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/common/typography/Text.tsx
var Text = __webpack_require__(51306);
// EXTERNAL MODULE: ./src/components/common/PimImage.tsx
var PimImage = __webpack_require__(43573);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
// EXTERNAL MODULE: ./src/utils/casePathEmptyString.ts
var casePathEmptyString = __webpack_require__(12732);
// EXTERNAL MODULE: ./src/modules/products/components/ProductLogo.tsx + 3 modules
var ProductLogo = __webpack_require__(1036);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageSctSection/ProductPageSctSectionItem.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 335px;\n  margin-bottom: 16px;\n\n  ",
        " {\n    width: 335px;\n    height: 335px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 340px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      flex-direction: row;\n      max-width: 1120px;\n      ",
        " {\n        margin-left: 210px;\n        ",
        " {\n          margin-left: 0;\n          margin-right: 124px;\n        }\n      }\n      ",
        " {\n        min-width: 427px;\n        height: 600px;\n        margin-top: -238px;\n      }\n      ",
        " {\n        height: 616px;\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  margin-top: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}













var ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageSctSectionItem__ImageContainer",
    componentId: "sc-fa2ffd9e-0"
})(_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ImageInnerContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageSctSectionItem__ImageInnerContainer",
    componentId: "sc-fa2ffd9e-1"
})(_templateObject1());
var ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageSctSectionItem__ContentContainer",
    componentId: "sc-fa2ffd9e-2"
})(_templateObject2());
var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageSctSectionItem__Container",
    componentId: "sc-fa2ffd9e-3"
})(_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, (0,casePathEmptyString/* casePathEmptyString */.Q)("$singular")((0,styled_components_browser_esm.css)(_templateObject3(), ContentContainer, theme/* dirRTL */.gX, ImageContainer, ImageInnerContainer)));
var Description = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).withConfig({
    displayName: "ProductPageSctSectionItem__Description",
    componentId: "sc-fa2ffd9e-4"
})(_templateObject5());
var StyledButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "ProductPageSctSectionItem__StyledButton",
    componentId: "sc-fa2ffd9e-5"
})(_templateObject6());
var ProductPageSctSectionItem = function(param) {
    var name = param.name, code = param.code, tagline = param.tagline, image = param.image, singular = param.singular, description = param.description;
    var _ = (0,lib.useTranslate)()._;
    var descriptionToDisplay = description !== null && description !== void 0 ? description : tagline;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        $singular: singular,
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageInnerContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                        src: image.id,
                        layout: "fill",
                        objectFit: "cover",
                        sizes: "100vw"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLogo/* ProductLogo */.q, {
                        name: name,
                        code: code
                    }),
                    descriptionToDisplay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: descriptionToDisplay
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                        href: route/* route.products */.BC.products().page({
                            code: code
                        }),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
                            forwardedAs: "a",
                            variant: "secondary",
                            children: [
                                _("Discover"),
                                " ",
                                name
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./vendor/mods/styled-components/index.tsx
var styled_components = __webpack_require__(10395);
// EXTERNAL MODULE: ./src/modules/products/hooks/useProductAttributes.ts
var useProductAttributes = __webpack_require__(50999);
// EXTERNAL MODULE: ./src/modules/products/hooks/useTitlesDictionary.ts
var useTitlesDictionary = __webpack_require__(76249);
// EXTERNAL MODULE: ./src/models/pim/dictionaries.ts
var dictionaries = __webpack_require__(56987);
// EXTERNAL MODULE: ./src/components/common/StickyMenu/StickyMenuSection.tsx
var StickyMenuSection = __webpack_require__(226);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageSctSection/index.tsx




function ProductPageSctSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: 48px;\n\n  ",
        " {\n    gap: 110px;\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    ProductPageSctSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageSctSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 380px;\n\n  ",
        " {\n    margin-bottom: 32px;\n    width: 100%;\n  }\n"
    ]);
    ProductPageSctSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageSctSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        margin: 30px 230px 48px auto;\n        ",
        " {\n          margin: 30px auto 48px 300px;\n        }\n      }\n\n      ",
        " {\n        margin-top: 16px;\n      }\n      ",
        " {\n        grid-template-columns: 1fr;\n      }\n    "
    ]);
    ProductPageSctSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductPageSctSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 32px 0;\n  background: ",
        ";\n\n  ",
        " {\n    padding: 56px 0;\n\n    ",
        "\n  }\n"
    ]);
    ProductPageSctSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




















var ProductPageSctSection_ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageSctSection__ContentContainer",
    componentId: "sc-22c8e7ac-0"
})(ProductPageSctSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var StyledHeading = (0,styled_components_browser_esm["default"])(Heading/* Heading */.X).withConfig({
    displayName: "ProductPageSctSection__StyledHeading",
    componentId: "sc-22c8e7ac-1"
})(ProductPageSctSection_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Section = (0,styled_components_browser_esm["default"])(StickyMenuSection/* StickyMenuSection */.T).withConfig({
    displayName: "ProductPageSctSection__Section",
    componentId: "sc-22c8e7ac-2"
})(ProductPageSctSection_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, (0,casePathEmptyString/* casePathEmptyString */.Q)("$singular")((0,styled_components_browser_esm.css)(ProductPageSctSection_templateObject2(), StyledHeading, theme/* dirRTL */.gX, ConstraintContainer/* ConstraintContainer */.a, ProductPageSctSection_ContentContainer)));
var ProductPageSctSection = function(product) {
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var _ = (0,lib.useTranslate)()._;
    var ref = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes), getProductAttribute = ref.getProductAttribute, getMultipleProductAttributes = ref.getMultipleProductAttributes;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTitlesDictionary/* useTitlesDictionary */.L)(dictionaries/* DictionaryTitlesCode.Sct */.v.Sct), 1), title = ref1[0];
    var items = (0,react.useMemo)(function() {
        if ((0,pim/* isProtocol */.uM)(product)) {
            return product.cross_sell.map(function(p) {
                return translateFn(p.related_products_id);
            });
        }
        return getMultipleProductAttributes(pim_attributes/* ProductAttributeCode.SctLinkGroup */.c.SctLinkGroup).map(function(attributes) {
            var ref, ref1, ref2;
            var ref3;
            var sctProduct = translateFn((ref3 = (ref = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.SctLinkGroupProduct */.c.SctLinkGroupProduct, attributes))) === null || ref === void 0 ? void 0 : ref.products_id) !== null && ref3 !== void 0 ? ref3 : {});
            var ref4, ref5;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sctProduct), {
                image: (ref4 = (ref1 = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.SctLinkGroupImage */.c.SctLinkGroupImage, attributes))) === null || ref1 === void 0 ? void 0 : ref1.directus_files_id) !== null && ref4 !== void 0 ? ref4 : sctProduct.image,
                description: (ref2 = translateFn((ref5 = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.SctLinkGroupText */.c.SctLinkGroupText, attributes))) !== null && ref5 !== void 0 ? ref5 : {})) === null || ref2 === void 0 ? void 0 : ref2.value
            });
        }).filter(function(p) {
            return !!p.code;
        });
    }, [
        product,
        getMultipleProductAttributes,
        getProductAttribute,
        translateFn
    ]);
    if (items.length === 0) {
        return null;
    }
    var isSingular = items.length === 1 && !!items[0].image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
            id: "sct",
            label: _("Other protocols"),
            index: 3,
            threshold: {
                desktop: 0.9,
                mobile: 0.8
            },
            $singular: isSingular,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading, {
                        children: title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: title.value
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageSctSection_ContentContainer, {
                        children: items.map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageSctSectionItem, (0,_object_spread/* default */.Z)({
                                singular: isSingular
                            }, item), i);
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 64308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useDictionaryDetailsQuery; }
/* harmony export */ });
/* unused harmony export fetchDictionaryDetailsQuery */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36305);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53100);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19162);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 



var fetchDictionaryDetailsQuery = function(apis, code) {
    return {
        queryKey: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(src_models_query__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.DictionaryDetails */ .S.DictionaryDetails).concat([
            code
        ]),
        queryFn: function() {
            return apis.pim.dictionaries.details(code);
        }
    };
};
var useDictionaryDetailsQuery = function(code) {
    var apis = (0,src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_1__/* .useAPIs */ .V)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(fetchDictionaryDetailsQuery(apis, code));
};


/***/ }),

/***/ 50999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useProductAttributes; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_models_pim_attributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74822);


var useProductAttributes = function(attributes) {
    return {
        getProductAttribute: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(codeOrCollection) {
            var attrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : attributes;
            return (0,src_models_pim_attributes__WEBPACK_IMPORTED_MODULE_1__/* .getProductAttribute */ .ur)(attrs, codeOrCollection);
        }, [
            attributes
        ]),
        getMultipleProductAttributes: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(codeOrCollection) {
            var attrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : attributes;
            return (0,src_models_pim_attributes__WEBPACK_IMPORTED_MODULE_1__/* .getMultipleProductAttributes */ .Qf)(attrs, codeOrCollection);
        }, [
            attributes
        ])
    };
};


/***/ }),

/***/ 76249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useTitlesDictionary; }
/* harmony export */ });
/* harmony import */ var src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70057);
/* harmony import */ var src_models_pim_dictionaries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56987);
/* harmony import */ var src_modules_products_hooks_useDictionaryDetailsQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64308);



var useTitlesDictionary = function(code) {
    var translateFn = (0,src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_0__/* .useTranslateItem */ .L)();
    var ref = (0,src_modules_products_hooks_useDictionaryDetailsQuery__WEBPACK_IMPORTED_MODULE_2__/* .useDictionaryDetailsQuery */ .F)(src_models_pim_dictionaries__WEBPACK_IMPORTED_MODULE_1__/* .DictionaryCode.Titles */ .e.Titles), dictionary = ref.data;
    var ref1;
    return (ref1 = dictionary === null || dictionary === void 0 ? void 0 : dictionary.entries.filter(function(entry) {
        return entry.code === code;
    }).map(translateFn)) !== null && ref1 !== void 0 ? ref1 : [];
};


/***/ }),

/***/ 69671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ esm_useInView; },
  "R": function() { return /* reexport */ esm_useObserver; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-hook-inview/dist/esm/useObserver.js

/**
 * useObserver
 * @param callback IntersectionObserverCallback
 * @param options IntersectionObserverInit
 * @param externalState React.ComponentState[]
 */
const useObserver = (callback, { root, rootMargin, threshold } = {}, externalState = []) => {
    const target = (0,react.useRef)(null);
    const observer = (0,react.useRef)(null);
    const setTarget = (0,react.useCallback)((node) => {
        if (target.current && observer.current) {
            observer.current.unobserve(target.current);
            observer.current.disconnect();
            observer.current = null;
        }
        if (node) {
            observer.current = new IntersectionObserver(callback, { root, rootMargin, threshold });
            observer.current.observe(node);
            target.current = node;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, root, rootMargin, threshold, ...externalState]);
    return setTarget;
};
/* harmony default export */ var esm_useObserver = (useObserver);

;// CONCATENATED MODULE: ./node_modules/react-hook-inview/dist/esm/useInView.js


/**
 * useInView
 * @param options IntersectionObserverInit
 * @param externalState React.ComponentState[]
 */
const useInView = ({ root, rootMargin, threshold, unobserveOnEnter, target, onEnter, onLeave } = {}, externalState = []) => {
    const [state, setState] = (0,react.useState)({
        inView: false,
        entry: null,
        observer: null,
    });
    const callback = (0,react.useCallback)(([entry], observer) => {
        const inThreshold = observer.thresholds.some((t) => entry.intersectionRatio >= t);
        const inView = inThreshold && entry.isIntersecting;
        setState({
            inView,
            entry,
            observer,
        });
        // unobserveOnEnter
        if (inView && unobserveOnEnter) {
            observer.unobserve(entry.target);
            observer.disconnect();
        }
        // Legacy callbacks
        if (inView) {
            onEnter === null || onEnter === void 0 ? void 0 : onEnter(entry, observer);
        }
        else {
            onLeave === null || onLeave === void 0 ? void 0 : onLeave(entry, observer);
        }
    }, [onEnter, onLeave, unobserveOnEnter]);
    const setTarget = esm_useObserver(callback, { root, rootMargin, threshold }, [unobserveOnEnter, ...externalState]);
    // Legacy 'target' option
    (0,react.useEffect)(() => {
        if (target === null || target === void 0 ? void 0 : target.current)
            setTarget(target.current);
    }, [target, setTarget]);
    return [setTarget, state.inView, state.entry, state.observer];
};
/* harmony default export */ var esm_useInView = (useInView);

;// CONCATENATED MODULE: ./node_modules/react-hook-inview/dist/esm/index.js




/***/ })

}]);